import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Table,
  Tag,
  Select,
  Pagination,
  Popconfirm,
  message,
  Input,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone, faEdit } from "@fortawesome/free-regular-svg-icons";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const List = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const { Option } = Select;
  const [pageDetails, setPageDetails] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [updatedAt, setUpdatedAt] = useState();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [attributesList, setAttributesList] = useState([]);
  const [searchByCategory, setSearchByCategory] = useState();
  const [searchByName, setSearchByName] = useState();
  const [searchByAttributes, setSearchByAttributes] = useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    try {
      (async () => {
        setLoading(true);
        const data = await axios
          .get("/product-list", {
            params: {
              limit,
              page,
              searchByCategory,
              searchByAttributes,
              searchByName,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setCount(data.data.count);
          setLoading(false);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [
    limit,
    page,
    updatedAt,
    searchByCategory,
    searchByAttributes,
    searchByName,
  ]);

  useEffect(() => {
    try {
      (async () => {
        var data = await axios.get("/category-all").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) setCategoryList(data.data.data);

        data = await axios.get("/attributes").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) setAttributesList(data.data.data);
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, []);

  const cancel = (e) => {
    console.log(e);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "BillingProduct",
      render: (variantsDetails) => variantsDetails.name,
    },
    {
      title: "Category",
      dataIndex: "BillingProduct",
      render: (variantsDetails) => variantsDetails.Category.name,
    },
    {
      title: "Attributes",
      dataIndex: "attributesDetails",
      render: (attributesDetails) =>
        attributesDetails &&
        attributesDetails.length > 0 &&
        attributesDetails.map((obj, i) => (
          <Tag color="#2db7f5" key={i}>
            {`${obj.Variant.name} : ${obj.name}`}
          </Tag>
        )),
    },
    {
      title: "Price",
      dataIndex: "price",
    },
    {
      title: "Web",
      dataIndex: "web",
      render: (text, record) => (
        <Tag
          role="button"
          color={record.active === false ? "#f50" : "#87d068"}
          onClick={() => {
            updateWebStatus(record);
          }}
        >
          {record.active ? "ACTIVATE" : "DEACTIVATE"}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (text, record) => (
        <Tag
          role="button"
          color={record.active === false ? "#f50" : "#87d068"}
          onClick={() => {
            updateStatus(record);
          }}
        >
          {record.active ? "ACTIVATE" : "DEACTIVATE"}
        </Tag>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <>
          <FontAwesomeIcon
            role="button"
            icon={faEdit}
            onClick={() => {
              navigate(`/update-products/${record.id}`);
            }}
          />
          <Popconfirm
            title="Delete the product"
            description="Are you sure to delete this product?"
            onConfirm={() => {
              handleDelete(record);
            }}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <FontAwesomeIcon
              role="button"
              icon={faTrash}
              style={{ color: "red" }}
            />
          </Popconfirm>
          <Popconfirm
            title="Clone the product"
            description="Are you sure to clone this product?"
            onConfirm={() => {
              handleClone(record);
            }}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <FontAwesomeIcon icon={faClone} role="button" />
          </Popconfirm>
        </>
      ),
    },
  ];

  const updateStatus = async (details) => {
    let obj = { id: details.id, active: !details.active };
    const data = await axios.patch("/product-update", obj).catch((error) => {
      Helper.ErrorHanlder(error);
    });
    if (data && data.data) {
      setUpdatedAt(Date.now());
      Notification.success("Staus updated successfully");
    }
  };

  const updateWebStatus = async (details) => {
    let obj = { id: details.id, active: !details.active };
    const data = await axios
      .patch("/update-web-status-product", obj)
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      setUpdatedAt(Date.now());
      Notification.success("Staus updated successfully");
    }
  };

  const handleChange = (value) => {
    setPage(1);
    setLimit(value);
  };

  const handleDelete = async (value) => {
    const data = await axios
      .delete("/product-delete", { data: value })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      setUpdatedAt(Date.now());
      Notification.success("Deleted successfully");
    }
  };

  const handleClone = async (value) => {
    const data = await axios.post("/product-clone", value).catch((error) => {
      Helper.ErrorHanlder(error);
    });
    if (data && data.data) {
      setUpdatedAt(Date.now());
      Notification.success("Cloned successfully");
    }
  };

  return (
    <Container>
      <Row>
        <Col md={12}>
          <div>
            <div className="deactive-btn">
              <Button
                type="primary"
                className="addnew-btn"
                onClick={(e) => {
                  navigate("/product-craete");
                }}
              >
                Add New
              </Button>
            </div>
            <div className="product-search">
              <Input
                placeholder="Name"
                width={"100%"}
                style={{ marginRight: "20px" }}
                onChange={(e) => {
                  setPage(1);
                  setSearchByName(e.target.value);
                }}
              />

              <div className="input-group search">
                <Select
                  className="text-start"
                  style={{ width: "96%", height: "100%" }}
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  validatetrigger="onChange"
                  onChange={(input) => {
                    setPage(1);
                    setSearchByCategory(input);
                  }}
                >
                  <Option value={""}>Select</Option>
                  {categoryList.map((i) => (
                    <Option key={i.id} value={i.id}>
                      {i.name}
                    </Option>
                  ))}
                </Select>
              </div>
              {searchByCategory && (
                <div className="input-group search">
                  <Select
                    mode="multiple"
                    className="text-start"
                    style={{ width: "96%", height: "100%" }}
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    validatetrigger="onChange"
                    onChange={(input) => {
                      setPage(1);
                      setSearchByAttributes(input);
                    }}
                  >
                    <Option value={""}>Select</Option>
                    {attributesList.map((i) => (
                      <Option key={i.id} value={i.id}>
                        {i.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
            </div>
            <Table
              columns={columns}
              dataSource={pageDetails}
              pagination={false}
              loading={loading}
              rowKey="id"
            />
            <div className="pagination">
              <Select
                defaultValue={limit}
                style={{ width: 120 }}
                onChange={handleChange}
                options={[
                  {
                    value: 5,
                    label: "5",
                  },
                  {
                    value: 10,
                    label: "10",
                  },
                  {
                    value: 20,
                    label: "20",
                  },
                  {
                    value: 25,
                    label: "25",
                  },
                ]}
              />
              {loading === false && (
                <Pagination
                  defaultCurrent={page}
                  pageSize={limit}
                  showSizeChanger={false}
                  total={count}
                  onChange={setPage}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default List;
